import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Grid, Hide, Rectangle, Shadow, Space, Typography } from '@pitchero/react-ui';
import { find } from 'lodash';
import Icon from '../icon';
import { Trans } from '../../lib/i18n';
import Bowler from './scorecard-bowler';

const ScorecardBowling = ({ bowlers, team }) => {
  const hasExtrasSummary = find(bowlers, (bowler) => bowler.extrasSummary !== null) !== null;
  const gridColumns = `minmax(100px, 50%) repeat(${hasExtrasSummary ? 6 : 5}, 1fr)`;
  const gridResponsive = [
    { maxWidth: 'tab', props: { columns: 'minmax(100px, 40%) repeat(5, 1fr)' } },
  ];
  return (
    <Space bottom="large">
      <Shadow>
        <Rectangle radius="roundedTop" fill="alabaster">
          <Cushion
            all="small"
            left="medium"
            responsive={[{ maxWidth: 'tab', props: { left: 'small' } }]}
            component="div"
          >
            <Grid columns={gridColumns} responsive={gridResponsive} alignItems="center">
              <Typography component="div" color="black" preset="tag--large">
                <Space right="xsmall">
                  <Icon name="cricket-ball" size={18} topOffset={4} />
                </Space>
                <Trans i18nKey="teams:bowling_title">Bowling</Trans>
              </Typography>
              <Typography component="div" color="dustygrey" preset="description" align="center">
                <Trans i18nKey="teams:overs_table_header">0</Trans>
              </Typography>
              <Typography component="div" color="dustygrey" preset="description" align="center">
                <Trans i18nKey="teams:maidens_table_header">M</Trans>
              </Typography>
              <Typography component="div" color="dustygrey" preset="description" align="center">
                <Trans i18nKey="teams:runs_table_header">R</Trans>
              </Typography>
              <Typography component="div" color="dustygrey" preset="description" align="center">
                <Trans i18nKey="teams:wickets_table_header">W</Trans>
              </Typography>
              <Typography component="div" color="dustygrey" preset="description" align="center">
                <Trans i18nKey="teams:economy_table_header">Econ.</Trans>
              </Typography>
              {hasExtrasSummary && (
                <Hide maxWidth="tab">
                  <Typography component="div" color="dustygrey" preset="description" align="center">
                    <Trans i18nKey="teams:extras_table_header">Extras</Trans>
                  </Typography>
                </Hide>
              )}
            </Grid>
          </Cushion>
        </Rectangle>
        {bowlers.map((bowler) => (
          <Bowler
            key={bowler.id}
            {...bowler}
            gridColumns={gridColumns}
            gridResponsive={gridResponsive}
            hasExtrasSummary={hasExtrasSummary}
            teamId={team.oppositionTeamId}
          />
        ))}
      </Shadow>
    </Space>
  );
};

ScorecardBowling.propTypes = {
  bowlers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  team: PropTypes.shape({
    oppositionTeamId: PropTypes.number,
  }),
};

ScorecardBowling.defaultProps = {
  team: {
    oppositionTeamId: null,
  },
};

export default ScorecardBowling;
